import { COUNTRIES } from "../data/countriesList";

const COUNTRY_SET = new Set(COUNTRIES.map((c) => c.value));

/**
 * Geo-detected ISO alpha-2 for pricing (any sovereign country in our list).
 * @returns {Promise<string | null>}
 */
export async function fetchSuggestedPricingCountryIso() {
  if (typeof window === "undefined") return null;
  try {
    const res = await fetch(`${window.location.origin}/client-country`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;
    const ct = res.headers.get("content-type") || "";
    if (!ct.includes("application/json")) return null;
    const data = await res.json();
    const c = String(data.country || "")
      .trim()
      .toUpperCase();
    if (!/^[A-Z]{2}$/.test(c) || !COUNTRY_SET.has(c)) return null;
    return c;
  } catch {
    return null;
  }
}

export function countryLabelForCode(code) {
  return COUNTRIES.find((c) => c.value === code)?.label || code;
}

/**
 * @param {string} currencyCode
 * @param {number} amount
 */
export function formatPricingAmount(currencyCode, amount) {
  const code = String(currencyCode || "USD").toUpperCase();
  const symbols = { USD: "$", GBP: "£", EUR: "€", AUD: "A$", CAD: "C$" };
  const symbol = symbols[code] || `${code} `;
  const n = Number(amount);
  if (!Number.isFinite(n)) return `${symbol}—`;
  const rounded = Math.round(n * 100) / 100;
  if (Number.isInteger(rounded)) return `${symbol}${rounded}`;
  return `${symbol}${rounded.toFixed(2)}`;
}
